<template>
  <div class="workordertemplate">
      <div class="navbar">
          <div class="btn">
              <button class="adjustmentBtn" @click="adjustmentClick" v-if="finish===1">
                        <span class="btn-txt" style="cursor: pointer">
                            调整顺序
                       </span>

              </button>
              <button class="finishBtn"  @click="finishClick" v-if="finish===0">
                        <span class="btn-txt" style="cursor: pointer">
                            完成
                       </span>
              </button>


              <button class="addTemplate" style="cursor: pointer" @click="addTemplate">
                        <span class="btn-txt">
                            新增模板
                        </span>
              </button>
          </div>
      </div>
      <div class="contain">
                 <!-- <div class="workOrderTemHeader">
                      <div class="sequence"><span>顺序</span></div>
                      <div class="templateName"><span>模板名称</span></div>
                      <div class="templateDescription"><span>模板描述</span></div>
                      <div class="templateOperation"><span>操作</span></div>
                  </div>-->
                  <div class="statusinfos">

                              <div v-if="finish===1">
                                  <template-info
                                          :templateList="template.list"
                                          :count="count"
                                          @deleteTemplate="deleteTemplate"



                                  />
                              </div>
                              <div v-if="finish===0">
                                  <template-info
                                          :count="count"
                                          :templateList="template.list"
                                          @deleteTemplate="deleteTemplate"
                                          @resortTemplate="resortTemplate"
                                  />
                              </div>

                  </div>
      </div>
  </div>
</template>

<script>
    import TemplateInfo from "./templateinfo/TemplateInfo";

    export default {
        name: "WorkOrderTempate",
        components: {TemplateInfo},
        data(){
            return{
                lengths:0,
                count:true,
                finish:1,
                template:{
                    list:[]
                 },
                templateResort:[],
                templateIdResort:[]

            }
        },
        mounted(){
            this.$nextTick(() => {
                this.getWorkOrderTemplate()
            })
        },
        methods:{
            //获取工单模板
            getWorkOrderTemplate(){
                this.$http.get('/api/template/list').then(res=>{
                    this.template.list=res.data.data
                })
            },
            postTemplateResort(){
                let templateIdResort=[]
                this.templateResort.forEach(item=>{
                    templateIdResort.push(item.id)
                })
                // templateIdResort.reverse();
                this.$http.post('/api/template/resort',templateIdResort).then(res=>{
                    if(res.data.code==='0')
                    {
                        this.$message.success('顺序调整完成')
                    }
                    this.getWorkOrderTemplate()
                })

            },
            adjustmentClick(){
                this.count=!this.count;
                this.finish=0
            },
            finishClick(){
                this.count=!this.count;
                this.finish=1
                this.postTemplateResort()
            },
            addTemplate(){
                this.$router.push('addtemplate')
              /*  this.$router.push('tem')*/
            },
            deleteTemplate(){
                this.getWorkOrderTemplate()
            },
            resortTemplate(templateResort){
                this.templateResort=templateResort
                console.log( this.templateResort)
            }


        }
    }
</script>

<style scoped lang="less">
@import "../../assets/less/workordertemplate/workordertemplate";
.flip-list-move {
    transition: transform 1s;
}
</style>